import request from '@/utils/request'

// 获取员工配置
export function SearchEmployeeConfigs(data) {
  return request({
    url: '/api/app/employee/search-config',
    method: 'get',
    params: data
  })
}

// 获取员工配置
export function GetEmployeeDayWorkConfigs(data) {
  return request({
    url: '/api/app/employee/configs',
    method: 'get',
    params: data
  })
}

// 更新员工配置
export function SetEmployeeDayWorkConfigs(data) {
  return request({
    url: '/api/app/employee/config',
    method: 'post',
    data
  })
}

// 删除员工配置
export function DeleteEmployeeDayWorkConfig(data) {
  return request({
    url: `/api/app/employee/${data.id}/config/`,
    method: 'delete'
  })
}

// 员工工作记录
export function GetEmployeeDayWorks(data) {
  return request({
    url: '/api/app/employee/day-works',
    method: 'get',
    params: data
  })
}

// 员工按小时的工作统计
export function GetEmployeeHourWorkStatistics(data) {
  return request({
    url: '/api/app/employee/daily-hourly-work-statistics',
    method: 'get',
    params: data
  })
}

// 员工工作统计
export function DayWorkStatistics(data) {
  return request({
    url: '/api/app/employee/day-work-statistics',
    method: 'post',
    data
  })
}

// 审核员工工作记录
export function AuditDayWork(data) {
  return request({
    url: '/api/app/employee/audit-day-work',
    method: 'post',
    data
  })
}

// 更新员工工作记录
export function HandleDayWork(data) {
  return request({
    url: '/api/app/employee/handle-day-work',
    method: 'post',
    data
  })
}

// 员工挪车服务区列表
export function GetEmployeeMoveTaskArea(data) {
  return request({
    url: `/api/app/employee/move-task-areas`,
    method: 'get',
    params: data
  })
}

// 员工挪车统计
export function GetEmployeeMoveTaskStatistics(data) {
  return request({
    url: '/api/app/employee/move-task-statistics',
    method: 'get',
    params: data
  })
}

// 员工每日挪车统计
export function GetEmployeeMoveTaskDailyStatistics(data) {
  return request({
    url: '/api/app/employee/move-task-daily-statistics',
    method: 'get',
    params: data
  })
}

// 员工挪车列表
export function GetEmployeeMoveTasks(data) {
  return request({
    url: '/api/app/employee/move-tasks',
    method: 'get',
    params: data
  })
}

// 员工换电统计
export function GetEmployeeBatteryTaskStatistics(data) {
  return request({
    url: '/api/app/employee/battery-change-task-statistics',
    method: 'get',
    params: data
  })
}

// 员工换电对应的服务区列表
export function GetEmployeeBatteryTaskAreas(data) {
  return request({
    url: '/api/app/employee/battery-change-task-areas',
    method: 'get',
    params: data
  })
}

// 员工换电列表
export function GetEmployeeBatteryTasks(data) {
  return request({
    url: '/api/app/employee/battery-change-tasks',
    method: 'get',
    params: data
  })
}

// 员工维修统计
export function GetEmployeeMaintenanceStatistics(data) {
  return request({
    url: '/api/app/employee/maintenance-log-statistics',
    method: 'get',
    params: data
  })
}

// 员工维修对应的服务区列表
export function GetEmployeeMaintenanceTaskAreas(data) {
  return request({
    url: '/api/app/employee/maintenance-log-areas',
    method: 'get',
    params: data
  })
}

// 员工维修列表
export function GetEmployeeMaintenanceTasks(data) {
  return request({
    url: '/api/app/employee/maintenance-logs',
    method: 'get',
    params: data
  })
}

// 员工保单列表
export function GetEmployeePolicies(data) {
  return request({
    url: '/api/app/employee-policy',
    method: 'get',
    params: data
  })
}

// 新增员工保单
export function CreateEmployeePolicy(data) {
  return request({
    url: '/api/app/employee-policy',
    method: 'post',
    data
  })
}

// 修改员工保单（有绑定时保单号不可改）
export function UpdateEmployeePolicy(id, data) {
  return request({
    url: `/api/app/employee-policy/${id}`,
    method: 'put',
    data
  })
}

// 删除员工保单（有绑定禁删）
export function DeleteEmployeePolicy(id) {
  return request({
    url: `/api/app/employee-policy/${id}`,
    method: 'delete'
  })
}

// 导入员工保单（JSON，按保单号新增/更新）
export function ImportEmployeePolicy(file) {
  const data = new FormData()
  data.append('File', file)
  return request({
    url: '/api/app/employee-policy/import',
    method: 'post',
    data
  })
}

// 导出员工保单（JSON，可直接回导）
export function ExportEmployeePolicy(data) {
  return request({
    url: '/api/app/employee-policy/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 迁移存量人员保险（旧 EmployeeInsurances → 保单主档 + 绑定，幂等）
export function MigrateLegacyEmployeeInsurance() {
  return request({
    url: '/api/app/employee-policy/migrate-legacy',
    method: 'post'
  })
}

// 员工保单绑定列表（每人一行：显示该员工当前的保险）
export function GetEmployeeInsuranceBindings(data) {
  return request({
    url: '/api/app/employee-insurance-binding',
    method: 'get',
    params: data
  })
}

// 按人查保险历史（该员工名下全部绑定，含过期/续保）
export function GetEmployeeInsuranceBindingHistory(data) {
  return request({
    url: '/api/app/employee-insurance-binding/history-list',
    method: 'get',
    params: data
  })
}

// 导入员工保险绑定（JSON，按 身份证+保单号+开始日期 新增/更新）
export function ImportEmployeeInsuranceBindings(file) {
  const data = new FormData()
  data.append('File', file)
  return request({
    url: '/api/app/employee-insurance-binding/import',
    method: 'post',
    data
  })
}

// 导出员工保险绑定（JSON，可直接回导）
export function ExportEmployeeInsuranceBindings(data) {
  return request({
    url: '/api/app/employee-insurance-binding/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 员工档案列表
export function GetEmployeeArchives(data) {
  return request({
    url: '/api/app/employee-archive',
    method: 'get',
    params: data
  })
}

// 员工档案详情
export function GetEmployeeArchive(data) {
  return request({
    url: `/api/app/employee-archive/${data.id}`,
    method: 'get'
  })
}

// 修改员工档案（身份证号不可改）
export function UpdateEmployeeArchive(data) {
  return request({
    url: `/api/app/employee-archive/${data.id}`,
    method: 'put',
    data
  })
}

// 钉钉审批 API 日期范围同步
export function SyncEmployeeArchiveDingtalk(data) {
  return request({
    url: '/api/app/employee-archive/dingtalk-sync',
    method: 'post',
    data
  })
}

// 钉钉审批导入同名多命中后的确认离职
export function ConfirmEmployeeArchiveImport(data) {
  return request({
    url: '/api/app/employee-archive/confirm-import',
    method: 'post',
    data
  })
}

// 入离职记录列表
export function GetEmployeeEmploymentRecords(data) {
  return request({
    url: '/api/app/employee-employment-record',
    method: 'get',
    params: data
  })
}

// 手动入职/离职（创建一条入离职记录；入职且身份证无档案时自动建档）
export function CreateEmployeeEmploymentRecord(data) {
  return request({
    url: '/api/app/employee-employment-record',
    method: 'post',
    data
  })
}

// 删除入离职记录（仅手动记录可删，删除后档案状态按剩余记录重算）
export function DeleteEmployeeEmploymentRecord(data) {
  return request({
    url: `/api/app/employee-employment-record/${data.id}`,
    method: 'delete'
  })
}